import { Col, Row } from 'antd';
import React, { useMemo } from 'react';
import { GRID_COLUMNS } from '../../../../../utils/fn/medias';
import MediaCard from './MediaCard';
import MediaCardSkeleton from './MediaCardSkeleton';

const MediaGridView = ({
  medias,
  setHasRejectedMedias,
  viewMode,
  selectedMediaIds,
  onMediaToggle,
  onValidateMedia,
  isLoading,
}) => {
  const columns = useMemo(
    () => GRID_COLUMNS[viewMode] || GRID_COLUMNS.large,
    [viewMode]
  );
  const gutterSize = useMemo(
    () => (viewMode === 'large' ? [16, 16] : [12, 12]),
    [viewMode]
  );

  return (
    <div
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '8px 16px',
      }}
    >
      <Row gutter={gutterSize}>
        {isLoading
          ? Array.from({ length: 20 }).map((_, index) => (
              <Col key={`skeleton-${index}`} {...columns}>
                <MediaCardSkeleton size={viewMode} />
              </Col>
            ))
          : medias?.map((media) => (
              <Col key={media.id} {...columns}>
                <MediaCard
                  setHasRejectedMedias={setHasRejectedMedias}
                  media={media}
                  size={viewMode}
                  isSelected={selectedMediaIds?.includes(media.id)}
                  onToggle={onMediaToggle}
                  onValidateMedia={onValidateMedia}
                />
              </Col>
            ))}
      </Row>
    </div>
  );
};

export default MediaGridView;
